const Enum = Object.freeze

const BOOKING_STATUS = Enum({ //these are category_ids of the associate modifiers
  HOLD: 1,
  BOOKED: 2,
  CANCELLED: 3,
  NO_SHOW: 4,
  EXPIRED: 5,
  CHECKED_IN: 6,
  CHECKED_OUT: 7

})

export { BOOKING_STATUS }